/* eslint-disable default-case */
/* eslint-disable no-param-reassign */
import produce from 'immer';
import { startOfMonth, endOfMonth, subMonths } from 'date-fns';
import {
  networkPerformanceDownloadReport,
  networkPerformanceGetDashboard,
  networkPerformanceSetDateRange,
  networkPerformanceSetGranularity,
  networkPerformanceSetStudios,
} from './actions';

const initialState = {
  dateRange: {
    startDate: startOfMonth(
      subMonths(new Date(), new Date().getDate() === 1 ? 2 : 1)
    ),
    endDate: endOfMonth(
      subMonths(new Date(), new Date().getDate() === 1 ? 2 : 1)
    ),
  },
  studioIds: [],
  // Period bucketing of the dashboard: whole months or whole Sun–Sat weeks.
  granularity: 'month',
  dashboard: null,
  loading: false,
  downloading: false,
  error: null,
};

const reducer = produce((draft, { type, payload }) => {
  switch (type) {
    case networkPerformanceSetDateRange.toString():
      draft.dateRange = payload;
      break;
    case networkPerformanceSetStudios.toString():
      draft.studioIds = payload;
      break;
    case networkPerformanceSetGranularity.toString():
      draft.granularity = payload;
      break;
    case networkPerformanceGetDashboard.REQUEST:
      draft.loading = true;
      draft.error = null;
      break;
    case networkPerformanceGetDashboard.SUCCESS:
      draft.dashboard = payload;
      draft.error = null;
      break;
    case networkPerformanceGetDashboard.FAILURE:
      draft.dashboard = null;
      draft.error = payload;
      break;
    case networkPerformanceGetDashboard.FULFILL:
      draft.loading = false;
      break;
    case networkPerformanceDownloadReport.REQUEST:
      draft.downloading = true;
      break;
    case networkPerformanceDownloadReport.FULFILL:
      draft.downloading = false;
      break;
  }
}, initialState);

export default reducer;
